import { render, staticRenderFns } from "./SurveyQuestions.vue?vue&type=template&id=3bc9a748&scoped=true"
import script from "./SurveyQuestions.vue?vue&type=script&lang=js"
export * from "./SurveyQuestions.vue?vue&type=script&lang=js"
import style0 from "./SurveyQuestions.vue?vue&type=style&index=0&id=3bc9a748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc9a748",
  null
  
)

export default component.exports